<app-component-loader />

<app-shared-dialog (dialogClosed)="onClose()">
  <ng-container dialog-header>
    <section class="p-6 pb-0">
      <h1 class="font-black text-[var(--ov-dialog-header-font-size)]">
        {{ stringEnum.LOCATION_CHANGE_DIALOG_TITLE }}
      </h1>
      <p
        class="font-light text-[length:var(--ov-body-font-size)] text-[var(--ov-secondary-text-color)]"
      >
        {{ stringEnum.LOCATION_CHANGE_DIALOG_MESSAGE }}
      </p>
    </section>
  </ng-container>

  <ng-container dialog-body>
    <section class="mb-1">
      <div class="location-box">
        <mat-icon class="icon">{{ utilityEnum.LOCATION_ON_MAT_ICON }}</mat-icon>
        <input
          type="tel"
          inputmode="numeric"
          [placeholder]="stringEnum.ENTER_PIN_CODE_PLACEHOLDER"
          class="pin-input"
          [maxLength]="charLimitEnum.PINCODE_AND_OTP"
          [value]="pincode()"
          (input)="onPincodeInput($event)"
          (blur)="onPincodeBlur()"
        />
        <button
          mat-stroked-button
          color="primary"
          class="submit-btn"
          [disabled]="!isPincodeValid()"
          (click)="onCheckLocation()"
        >
          {{ stringEnum.SUBMIT_BUTTON_TEXT }}
        </button>
      </div>
      @if (pincodeTouched() && !isPincodeValid()) {
        <p
          class="text-[length:var(--ov-sub-msg-font-size)] text-[var(--ov-error-text-color)] font-normal"
        >
          {{ stringEnum.PINCODE_INVALID_ERR }}
        </p>
      }
      <button class="current-location" (click)="onAutoDetectLocation()">
        <mat-icon class="mr-1 material-icons-outlined">{{
          utilityEnum.LOCATION_MAT_ICON
        }}</mat-icon>
        <span class="font-bold text-[length:var(--ov-body-font-size)]">{{
          stringEnum.USE_CURRENT_LOCATION_TEXT
        }}</span>
      </button>
      @if (locationUnserviceable()) {
        <div class="mt-2">
          <p
            class="font-bold text-[length:var(--ov-body-font-size)] text-[var(--ov-danger-text-color)]"
          >
            {{ stringEnum.LOCATION_UNSERVICED_MESSAGE }}
          </p>
          <p class="font-light text-[length:var(--ov-sub-msg-font-size)]">
            {{ stringEnum.LOCATION_UNSERVICED_SUB_MESSAGE }}
          </p>
        </div>
      }
    </section>
    @if (isLoggedIn() && userAddress()) {
      <section>
        <span
          class="font-black text-[length:var(--ov-body-font-size)] text-[var(--ov-text-color)]"
          >{{ stringEnum.SAVED_ADDRESS }}</span
        >
        <div class="flex flex-col gap-1 p-2 bg-white border border-gray-100 rounded-[16px] mt-1">
          <div class="flex items-center justify-between border-b border-[var(--ov-border-color)]">
            <div class="flex items-center gap-2">
              <div class="bg-white rounded-lg shadow-sm h-[24px]">
                <mat-icon class="text-gray-700 material-icons-outlined">{{
                  utilityEnum.HOME_MAT_ICON
                }}</mat-icon>
              </div>
              <span
                class="font-bold text-[var(--ov-text-color)] text-[length:var(--ov-body-font-size)]"
                >{{ stringEnum.HOME }}</span
              >
            </div>

            <button
              mat-icon-button
              class="text-green-600 hover:text-green-700"
              (click)="onEditAddress()"
            >
              <mat-icon class="material-icons-outlined" color="primary">{{
                utilityEnum.EDIT_MAT_ICON
              }}</mat-icon>
            </button>
          </div>
          <p
            class="font-normal leading-[140%] text-[length:var(--ov-body-font-size)] text-[var(--ov-secondary-text-color)] mt-1 break-words"
          >
            {{ userAddress() }}
          </p>
        </div>
      </section>
    }
  </ng-container>

  <ng-container dialog-actions>
    <section class="px-6">
      <span class="font-black text-[length:var(--ov-body-font-size)] text-[var(--ov-text-color)]">{{
        stringEnum.POPULAR_CITIES
      }}</span>
      <mat-chip-listbox [multiple]="false" aria-label="City selection" class="flex flex-wrap gap-3">
        @for (city of popularCities(); track city?.name) {
          <mat-chip-option
            (selectionChange)="onCitySelected($event)"
            class="border border-[var(--ov-background-light-blue)]"
            [value]="city?.name"
          >
            <img matChipAvatar [src]="city?.iconUrl" [alt]="city?.alternativeText" />
            <span>{{ city?.name }}</span>
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </section>
  </ng-container>
</app-shared-dialog>
